var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBpLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.5 376.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#090;}.cls-2,.cls-3,.cls-4,.cls-5{fill-rule:evenodd;}.cls-3{fill:#9c0;}.cls-4{fill:#fff;}.cls-5{fill:#ffe600;}.cls-6{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.6,43.9c0,8.2-2.9,19.6-14.5,19.6-14,0-14-15.7-14-19s0-20.1,14.4-20.1C217.6,24.4,218.6,38.9,218.6,43.9ZM190.2,0h-9.4V60.5l-.2,9h9.1l.2-7.6a16.1,16.1,0,0,0,4.9,5.1A19.83,19.83,0,0,0,206,70.2a21.52,21.52,0,0,0,17.7-8.6c2.5-3.3,4.8-8.6,4.8-18.4,0-11-3.4-16-5.9-18.9-4.6-5.2-10.9-6.4-16-6.4-11.4,0-15.1,6.3-16.4,8.6V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M244.8,45.9c0-4.5,0-20.5,15-20.5,11.1,0,13.8,9.4,13.8,18.5,0,3.6-.5,10.8-4.1,15.7-3.2,4.4-8.2,4.9-10.6,4.9C245.7,64.6,244.8,52.1,244.8,45.9ZM235.7,89H245V64c2.7,4.4,8.1,7.5,15.4,7.5,12,0,22.9-8.2,22.9-27S273,18.4,262.2,18.4c-4.1,0-12.4,1.2-17.2,9.1l-.2-8.3h-9.5c.2,4.8.3,6,.3,8.2V89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161,123.7A196.77,196.77,0,0,0,141.7,89a204.88,204.88,0,0,0-19.3,34.7A132.36,132.36,0,0,1,141.7,150,126.8,126.8,0,0,1,161,123.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.5,342a196.77,196.77,0,0,0,19.3,34.7c3.4-5.2,12.2-18,19.3-34.7a136.42,136.42,0,0,1-19.3-26.3A136.42,136.42,0,0,1,122.5,342Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.5,123.7a210.34,210.34,0,0,0-30-26.1,199.92,199.92,0,0,0-6.2,39.2,132,132,0,0,1,27.1,18.1A128.92,128.92,0,0,1,122.5,123.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161,342a204.87,204.87,0,0,0,30,26.1,201.35,201.35,0,0,0,6.2-39.2,136.23,136.23,0,0,1-27.1-18.1A135,135,0,0,1,161,342Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.3,136.8a198.92,198.92,0,0,0-37.1-14.2,202.76,202.76,0,0,0,7.6,39,131,131,0,0,1,31.6,7.7A134.52,134.52,0,0,1,86.3,136.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M197.1,328.9a198.92,198.92,0,0,0,37.1,14.2,202.76,202.76,0,0,0-7.6-39,131.41,131.41,0,0,1-31.6-7.8A126.15,126.15,0,0,1,197.1,328.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.9,191.4a133.45,133.45,0,0,1-13.1-29.8,200.84,200.84,0,0,0-39.7-.7,210.89,210.89,0,0,0,20.4,34A129.85,129.85,0,0,1,69.9,191.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213.5,274.3a129,129,0,0,1,13.1,29.8,200.84,200.84,0,0,0,39.7.7,210,210,0,0,0-20.5-34.1A127.91,127.91,0,0,1,213.5,274.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.5,194.9A208.74,208.74,0,0,0,0,207.8a205.46,205.46,0,0,0,30.9,25,130.25,130.25,0,0,1,29.2-14.4A134.66,134.66,0,0,1,37.5,194.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.6,232.8a130.25,130.25,0,0,1-29.2,14.4,130.41,130.41,0,0,1,22.5,23.5,202.89,202.89,0,0,0,37.5-12.9A197.87,197.87,0,0,0,252.6,232.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.1,247.2a130.25,130.25,0,0,1-29.2-14.4A205.46,205.46,0,0,0,0,257.8a200.89,200.89,0,0,0,37.5,12.9A138.25,138.25,0,0,1,60.1,247.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M223.4,218.4a132.4,132.4,0,0,1,29.2,14.4,205.46,205.46,0,0,0,30.9-25A200.89,200.89,0,0,0,246,194.9,134.66,134.66,0,0,1,223.4,218.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.5,270.8a196.25,196.25,0,0,0-20.4,34.1,209.21,209.21,0,0,0,39.7-.7,133.45,133.45,0,0,1,13.1-29.8A139.85,139.85,0,0,1,37.5,270.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.9,194.9a205.79,205.79,0,0,0,20.5-34.1,209.24,209.24,0,0,0-39.7.7,133.45,133.45,0,0,1-13.1,29.8A133.79,133.79,0,0,1,245.9,194.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.4,296.3a136.29,136.29,0,0,1-31.6,7.8,202.76,202.76,0,0,0-7.6,39,198.92,198.92,0,0,0,37.1-14.2A135.65,135.65,0,0,1,88.4,296.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195,169.3a131,131,0,0,1,31.6-7.7,202.76,202.76,0,0,0,7.6-39,198.92,198.92,0,0,0-37.1,14.2A125.39,125.39,0,0,1,195,169.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.3,328.9a199.92,199.92,0,0,0,6.2,39.2,203.8,203.8,0,0,0,30-26.1,129.72,129.72,0,0,1-9.1-31.3A132.64,132.64,0,0,1,86.3,328.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M197.1,136.8a199.92,199.92,0,0,0-6.2-39.2,203.8,203.8,0,0,0-30,26.1,135,135,0,0,1,9.1,31.2A139.16,139.16,0,0,1,197.1,136.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.8,176.9a90.9,90.9,0,0,1,9.9-27,132.36,132.36,0,0,0-19.3-26.3,130.25,130.25,0,0,0-9.1,31.2A92.17,92.17,0,0,1,131.8,176.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.6,288.8a91.93,91.93,0,0,1-9.9,27A128.55,128.55,0,0,0,161,342.1a134.4,134.4,0,0,0,9.1-31.3A89.77,89.77,0,0,1,151.6,288.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M88.4,169.3a91.77,91.77,0,0,1,24.9,14.3,92.07,92.07,0,0,1,0-28.7,133.42,133.42,0,0,0-27.1-18.1A140,140,0,0,0,88.4,169.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M195,296.3A91.77,91.77,0,0,1,170.1,282a89.1,89.1,0,0,1-.1,28.7,133.42,133.42,0,0,0,27.1,18.1A125.66,125.66,0,0,0,195,296.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98.2,196.3a91.48,91.48,0,0,1-9.8-27,131,131,0,0,0-31.6-7.7,133.45,133.45,0,0,0,13.1,29.8A90.08,90.08,0,0,1,98.2,196.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M185.2,269.4a91.48,91.48,0,0,1,9.8,27,136.29,136.29,0,0,0,31.6,7.8,133.45,133.45,0,0,0-13.1-29.8A97.5,97.5,0,0,1,185.2,269.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.1,218.4a91.42,91.42,0,0,1,28.3-5,89.08,89.08,0,0,1-18.4-22,134.71,134.71,0,0,0-32.4,3.5A130.41,130.41,0,0,0,60.1,218.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M223.4,247.2a91.42,91.42,0,0,1-28.3,5,89.08,89.08,0,0,1,18.4,22,129.24,129.24,0,0,0,32.4-3.6A136.88,136.88,0,0,0,223.4,247.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.9,232.8a89.57,89.57,0,0,1-24.8-14.4,130.25,130.25,0,0,0-29.2,14.4,130.25,130.25,0,0,0,29.2,14.4A92.12,92.12,0,0,1,84.9,232.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M198.5,232.8a91.61,91.61,0,0,1,24.9,14.4,132.4,132.4,0,0,0,29.2-14.4,130.25,130.25,0,0,0-29.2-14.4A87.71,87.71,0,0,1,198.5,232.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.9,274.3a91.32,91.32,0,0,1,18.4-22,91.42,91.42,0,0,1-28.3-5,130.41,130.41,0,0,0-22.5,23.5A134.71,134.71,0,0,0,69.9,274.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M213.5,191.4a91.32,91.32,0,0,1-18.4,22,91.42,91.42,0,0,1,28.3,5,130.41,130.41,0,0,0,22.5-23.5A129.33,129.33,0,0,0,213.5,191.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98.2,269.4a90.08,90.08,0,0,1-28.3,4.9,133.45,133.45,0,0,0-13.1,29.8,131.41,131.41,0,0,0,31.6-7.8A91.92,91.92,0,0,1,98.2,269.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M185.2,196.3a90.08,90.08,0,0,1,28.3-4.9,129,129,0,0,0,13.1-29.8,131,131,0,0,0-31.6,7.7A88.75,88.75,0,0,1,185.2,196.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.8,288.8a89.77,89.77,0,0,1-18.5,22,131.06,131.06,0,0,0,9.1,31.3,132.36,132.36,0,0,0,19.3-26.3A94.85,94.85,0,0,1,131.8,288.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.3,282.1a90.3,90.3,0,0,1-24.9,14.3,129.94,129.94,0,0,0-2.1,32.5,136.23,136.23,0,0,0,27.1-18.1A89.1,89.1,0,0,1,113.3,282.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.6,176.9a92,92,0,0,1,18.5-22,128.92,128.92,0,0,0-9.1-31.2A136.42,136.42,0,0,0,141.7,150,89.29,89.29,0,0,1,151.6,176.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M170.1,183.6A88.88,88.88,0,0,1,195,169.3a129.94,129.94,0,0,0,2.1-32.5A136.23,136.23,0,0,0,170,154.9,89.1,89.1,0,0,1,170.1,183.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.9,205.9a75.61,75.61,0,0,0-18.6-22.2,79.38,79.38,0,0,0,9.9,27.2,77.9,77.9,0,0,0-25-14.5,78.66,78.66,0,0,0,18.6,22.2,77.12,77.12,0,0,0-28.5-5.1,77.12,77.12,0,0,0,25.1,14.4,76.87,76.87,0,0,0-28.5,5,79.74,79.74,0,0,0,28.5,5,77.12,77.12,0,0,0-25.1,14.4,77.12,77.12,0,0,0,28.5-5.1,77.31,77.31,0,0,0-18.6,22.2,78.7,78.7,0,0,0,25-14.5,77.36,77.36,0,0,0-9.9,27.2,79.94,79.94,0,0,0,18.6-22.2,78.48,78.48,0,0,0,0,29,78.81,78.81,0,0,0,9.9-27.2,78.07,78.07,0,0,0,9.9,27.2,78.48,78.48,0,0,0,0-29,78.53,78.53,0,0,0,18.6,22.2,77.62,77.62,0,0,0-10-27.2,78.32,78.32,0,0,0,25.1,14.5,77.31,77.31,0,0,0-18.6-22.2,77.12,77.12,0,0,0,28.5,5.1,79.15,79.15,0,0,0-25.1-14.5,76.87,76.87,0,0,0,28.5-5,79.35,79.35,0,0,0-28.5-5,77.12,77.12,0,0,0,25.1-14.4,77.12,77.12,0,0,0-28.5,5.1,77.71,77.71,0,0,0,18.7-22.2,78.32,78.32,0,0,0-25.1,14.5,77.62,77.62,0,0,0,10-27.2,79.94,79.94,0,0,0-18.6,22.2,78.48,78.48,0,0,0,0-29,78.07,78.07,0,0,0-9.9,27.2,78.07,78.07,0,0,0-9.9-27.2A76.85,76.85,0,0,0,131.9,205.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M131.9,205.9a78.48,78.48,0,0,1,0-29,89.77,89.77,0,0,0-18.5-22,89.14,89.14,0,0,0,0,28.7A80.41,80.41,0,0,1,131.9,205.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M151.5,259.8a78.48,78.48,0,0,1,0,29,92,92,0,0,0,18.5,22,92,92,0,0,0,.1-28.7A79,79,0,0,1,151.5,259.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M113.3,183.6a90.3,90.3,0,0,0-24.9-14.3,88.75,88.75,0,0,0,9.8,27,76.86,76.86,0,0,1,25,14.5A78.65,78.65,0,0,1,113.3,183.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M170.1,282.1A88.88,88.88,0,0,0,195,296.4a88.75,88.75,0,0,0-9.8-27,80.22,80.22,0,0,1-25.1-14.5A75,75,0,0,1,170.1,282.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M116.9,218.5a77.31,77.31,0,0,1-18.6-22.2A90.08,90.08,0,0,0,70,191.4a91.32,91.32,0,0,0,18.4,22A77.47,77.47,0,0,1,116.9,218.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M166.6,247.2a77.31,77.31,0,0,1,18.6,22.2,90.08,90.08,0,0,0,28.3,4.9,91.32,91.32,0,0,0-18.4-22A77.12,77.12,0,0,1,166.6,247.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M113.4,227.9a77.12,77.12,0,0,1-25.1-14.4,91.42,91.42,0,0,0-28.3,5,91,91,0,0,0,24.8,14.4A76.48,76.48,0,0,1,113.4,227.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M170,237.8a79.15,79.15,0,0,1,25.1,14.5,91.42,91.42,0,0,0,28.3-5,90.14,90.14,0,0,0-24.9-14.4A76.86,76.86,0,0,1,170,237.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.9,232.8a89.57,89.57,0,0,0-24.8,14.4,91.42,91.42,0,0,0,28.3,5,77.12,77.12,0,0,1,25.1-14.4A75.77,75.77,0,0,1,84.9,232.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M198.5,232.8a91.61,91.61,0,0,0,24.9-14.4,91.42,91.42,0,0,0-28.3-5A77.12,77.12,0,0,1,170,227.8,79,79,0,0,1,198.5,232.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M116.9,247.2a77.12,77.12,0,0,1-28.5,5.1,89.08,89.08,0,0,0-18.4,22,93,93,0,0,0,28.3-4.9A74.23,74.23,0,0,1,116.9,247.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M166.6,218.5a77.12,77.12,0,0,1,28.5-5.1,89.08,89.08,0,0,0,18.4-22,93,93,0,0,0-28.3,4.9A77.31,77.31,0,0,1,166.6,218.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M131.8,288.8a91.93,91.93,0,0,0,9.9,27,93.75,93.75,0,0,0,9.9-27,78.81,78.81,0,0,1-9.9-27.2A76.83,76.83,0,0,1,131.8,288.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M131.9,259.8A76.92,76.92,0,0,1,113.3,282a92.07,92.07,0,0,0,0,28.7,92,92,0,0,0,18.5-22A80.22,80.22,0,0,1,131.9,259.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98.2,269.4a91.48,91.48,0,0,0-9.8,27,91.77,91.77,0,0,0,24.9-14.3,79.38,79.38,0,0,1,9.9-27.2A78.7,78.7,0,0,1,98.2,269.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M151.6,176.9a90.9,90.9,0,0,0-9.9-27,92.68,92.68,0,0,0-9.9,27,78.07,78.07,0,0,1,9.9,27.2A78.07,78.07,0,0,1,151.6,176.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M151.5,205.9a77.16,77.16,0,0,1,18.6-22.2A89.09,89.09,0,0,0,170,155a92,92,0,0,0-18.5,22A73.89,73.89,0,0,1,151.5,205.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M185.2,196.3a91.48,91.48,0,0,0,9.8-27,91.77,91.77,0,0,0-24.9,14.3,77.62,77.62,0,0,1-10,27.2A80.22,80.22,0,0,1,185.2,196.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 283.5,
    height: 376.7
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBpLogo);
export default __webpack_public_path__ + "static/media/bp-logo.4f647356ed9eb6669f43747feed15836.svg";
export { ForwardRef as ReactComponent };